import EditIcon from '@mui/icons-material/EditOutlined';
import { useMutation } from '@tanstack/react-query';
import { t } from 'i18next';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { postResourceModification } from '../../queries/overviewQueries';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import {
  clearPecrURLData,
  pecrURLData,
} from '../../reducers/pecr-url-data/slice';
import {
  clearResourceModificationData,
  resourceModificationData,
} from '../../reducers/resource-modification-data/slice';
import { summaryEditIcon } from '../../styles';

function EditResource({ siteId, pecrId, Container, disabled = false }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mutate: editResource } = useMutation({
    mutationFn: postResourceModification,
    onSuccess: (data, variables) => {
      dispatch(resourceModificationData(data));
      dispatch(
        pecrURLData({
          pecrId: pecrId,
          siteId: siteId,
          url: variables.url,
        })
      );
      navigate('../ResourceModification');
    },
    onError: () => {
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    },
  });

  const onEditIconClick = () => {
    dispatch(clearResourceModificationData([]));
    dispatch(clearPecrURLData({}));
    editResource({ pecrId, siteId });
  };
  return (
    <Container>
      <EditIcon
        sx={{
          ...summaryEditIcon,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
        }}
        onClick={() => {
          if (!disabled) {
            onEditIconClick();
          }
        }}
      />
    </Container>
  );
}

EditResource.propTypes = {
  siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pecrId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  Container: PropTypes.elementType,
  disabled: PropTypes.bool,
};

export default EditResource;
